import apiClient from '../utils/apiClient';
import { storage, apiUtils } from '../utils/commonUtils';

export const loginUser = async (email, password) => {
  try {
    const response = await apiClient.post('/login', { email, password });
    const raw = response.data;
    const message = raw?.message || 'Login successful';
    const token = raw?.token || raw?.access_token || raw?.data?.token || raw?.data?.access_token;
    const user = raw?.data?.user || raw?.user || raw?.data || {};

    return {
      success: true,
      data: user,
      token: token,
      message
    };
  } catch (error) {
    return apiUtils.handleError(error, 'Login failed. Please check your credentials.');
  }
};

export const logoutUser = async () => {
  try {
    storage.clearAuth();
    
    return {
      success: true,
      message: 'Logged out successfully'
    };
  } catch (error) {
    console.error('Error logging out:', error);
    return {
      success: false,
      message: error.message || 'Logout failed'
    };
  }
};

export const isAuthenticated = () => {
  return storage.isAuthenticated();
};

export const getStoredUser = () => {
  return storage.getUser();
};

export const storeUserData = (userData, token, rememberMe = false, email = '') => {
  try {
    storage.setUser(userData, rememberMe);
    storage.setToken(token, rememberMe);
    if (rememberMe) {
      storage.setRememberedEmail(email || userData?.email || '');
    } else {
      storage.clearRememberedEmail();
    }
    
    return true;
  } catch (error) {
    console.error('Error storing user data:', error);
    return false;
  }
};
